import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";
import React from "react";

export type WcTrueFalseToggleButtonProps = ToggleButtonGroupProps & {
  trueLabel?: string;
  falseLabel?: string;
};

export const WcTrueFalseToggleButton = ({ trueLabel, falseLabel, ...props }: WcTrueFalseToggleButtonProps) => (
  <ToggleButtonGroup exclusive={true} {...props}>
    <ToggleButton
      value={"TRUE"}
      sx={{
        minWidth: 40,
        borderRadius: 40,
        height: 35,
      }}
    >
      {trueLabel}
    </ToggleButton>
    <ToggleButton
      value={"FALSE"}
      sx={{
        minWidth: 40,
        borderRadius: 40,
        height: 35,
      }}
    >
      {falseLabel}
    </ToggleButton>
  </ToggleButtonGroup>
);
